/* eslint-disable no-undef */
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

    $(document).on('gform_confirmation_loaded', function(event, formId){
        // code to be trigger when confirmation page is loaded
        if(formId == 3) {
          $('.your-wishlist-form-and-list').addClass('form-sent');
        }
    });

    /**************************************************************
    -> Pageload animation
    **************************************************************/
   function pageYourWishlistLoadAnimation() {
    const tl = gsap.timeline({ delay: 0.25, duration: 0.25 })

    tl.to('.your-wishlist-top-section .top-container h2', { opacity: 1 })
    .to('.your-wishlist-top-section .top-container p', { opacity: 1 }, '>-0.15')
    .to('.your-wishlist-top-section .top-container .clear-wishlist', { opacity: 1 }, '>-0.25')
    .to('.your-wishlist-top-section .top-container .mobile-scroll-to-form', { opacity: 1 }, '>-0.25')
    .to('.your-wishlist-form-and-list .wrap-form', { opacity: 1 }, '>-0.25')
    .to('.your-wishlist-form-and-list .wrap-wishlist-list .empty-wishlist', { opacity: 1 }, '>-0.25')
    .to('.your-wishlist-form-and-list .wrap-wishlist-list .wishlist-item', { opacity: 1 , stagger: {
      each: 0.05,
      from: 'start',
      grid: 'auto',
      ease: 'linear',
    }}, '>-0.35')
  }
  pageYourWishlistLoadAnimation()

    /**************************************************************
    -> Add class to header to make it black
    **************************************************************/
    const turnHeaderBlack = () => {
      const header = document.querySelector('header');
      window.addEventListener('load', () => {
        header.classList.add('black-nav')
      })
    }
    turnHeaderBlack();

    /**************************************************************
    -> Scrolling to the form (Mobile only)
    **************************************************************/
    const scrollToFormOnlyMobile = () => {
      const scrollToFormBtn = document.querySelector('.mobile-scroll-to-form');

      scrollToFormBtn.addEventListener('click', () => {
        $('html, body').animate({scrollTop: $('#form-your-wishlist').offset().top - 60}, 500);
      })
    }
    scrollToFormOnlyMobile();

    /**************************************************************
    -> Creating correct url of wishlist landing to share on social
    **************************************************************/
   const socialWindow = url => {
    const left = (window.innerWidth - 570) / 2;
    const top = (window.innerHeight - 570) / 2;
    const params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left;
    window.open(url,'NewWindow',params);
  }

  const setShareLinks = () => {
    const shareLinkedin = document.querySelector('.share-linkedin');
    const shareTwitter = document.querySelector('.share-twitter');
    const shareFacebook = document.querySelector('.share-facebook');

    const baseUrl = window.location.origin;
    const queryIds = window.location.search;
    const linkToUrl = encodeURIComponent(`${baseUrl}/wishlist-landing/${queryIds}`)

    const textTwitterShare = encodeURIComponent('Look at the wishlist I just created on the Adams & Butler website : ')
    // var tweet = encodeURIComponent(document.querySelector('meta[property="og:description"]').getAttribute('content'));

    shareLinkedin.addEventListener('click', (e) => {
      e.preventDefault();
      socialWindow(`https://www.linkedin.com/shareArticle?mini=true&url=${linkToUrl}`);
    })

    shareTwitter.addEventListener('click', (e) => {
      e.preventDefault();
      socialWindow(`https://twitter.com/intent/tweet?url=${linkToUrl}&text=${textTwitterShare}`);
    })

    shareFacebook.addEventListener('click', (e) => {
      e.preventDefault();
      socialWindow(`https://www.facebook.com/sharer.php?u=${linkToUrl}`);
    })
  }
  setShareLinks();

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/your-wishlist.js